import React from 'react';
import { RemoveFilter, SaveNewFilter } from '~/components/Search';
import { RemovableOption, Select } from '~/components/Select';
import { ClinicList, PCPList, SearchValuesType, ServicesContext, initialSearch } from '~/services';
import { useServiceSubscribe } from '~/util';

export interface SavedFiltersProps {
    formVals: SearchValuesType;
    clinic?: ClinicList;
    PCP?: PCPList;
    selectFilter: (filter: SearchValuesType['filter']) => void;
}
export function SavedFilters({
    formVals,
    selectFilter,
    clinic = null,
    PCP = null,
}: SavedFiltersProps) {
    const context = React.useContext(ServicesContext);
    const [options, setOptions] = React.useState<SavedFilterOptionType[]>([]);
    const [toRemove, setToRemove] = React.useState('');
    const [saveNew, setSaveNew] = React.useState(false);

    const saveNewDisabled = React.useMemo(() => {
        if (clinic !== null && clinic.length > 0) return false;
        if (PCP !== null && PCP.length > 0) return false;
        return JSON.stringify(initialSearch) === JSON.stringify(formVals);
    }, [clinic, PCP, formVals]);

    function remove(e: React.MouseEvent<HTMLButtonElement>, value: string) {
        e.stopPropagation();
        setToRemove(value);
    }

    const loadFilters = React.useCallback(() => {
        const { savedFilters } = context.user.getSavedSearchData();
        setOptions(
            savedFilters.map((x: TODO_TYPEME) => ({
                value: x.label,
                label: x.label,
                remove,
            }))
        );
    }, [context.user]);

    React.useEffect(() => {
        loadFilters();
    }, [loadFilters]);
    useServiceSubscribe(context.user.events.savedSearchDataUpdated, loadFilters);

    function filterSelect(value: SavedFilterOptionType) {
        const { savedFilters } = context.user.getSavedSearchData();
        selectFilter(savedFilters.find((x: TODO_TYPEME) => x.label === value?.label));
    }

    if (toRemove) return <RemoveFilter filter={toRemove} onDismiss={() => setToRemove('')} />;

    if (saveNew)
        return (
            <SaveNewFilter
                formVals={formVals}
                clinic={clinic}
                PCP={PCP}
                onDismiss={() => setSaveNew(false)}
            />
        );

    return (
        <div className="row">
            <div className="col col-md-5 offset-md-1">
                <Select
                    components={{ Option: RemovableOption }}
                    isClearable
                    options={options}
                    value={
                        formVals.filter && {
                            label: formVals.filter.label,
                            value: formVals.filter.label,
                        }
                    }
                    placeholder="Saved Filters"
                    label="Saved Filters"
                    onChange={filterSelect}
                />
            </div>
            <div className="col col-md-5 text-end">
                <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() => setSaveNew(true)}
                    disabled={saveNewDisabled}
                >
                    Save New Filter
                </button>
            </div>
        </div>
    );
}

export interface SavedFilterOptionType {
    value: string;
    label: string;
    remove: (e: React.MouseEvent<HTMLButtonElement>, label: string) => void;
}
